import React from "react";
import { Helmet } from "react-helmet";

/**
 * VideoSchema Component
 * Generates JSON-LD for Google VideoObject structured data.
 * 
 * @param {string} title - Video title
 * @param {string} description - Video description
 * @param {string} thumbnailUrl - Absolute URL to the video thumbnail
 * @param {string} uploadDate - ISO 8601 date string (e.g., "2024-01-01T00:00:00Z")
 * @param {string} duration - ISO 8601 duration string (e.g., "PT1M33S")
 * @param {string} contentUrl - Direct link to the video file or embed
 * @param {string} embedUrl - URL where the video is embedded
 */
const VideoSchema = ({
    title,
    description,
    thumbnailUrl,
    uploadDate,
    duration,
    contentUrl,
    embedUrl,
}) => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": title,
        "description": description,
        "thumbnailUrl": [thumbnailUrl],
        "uploadDate": uploadDate,
        "duration": duration,
        "contentUrl": contentUrl || embedUrl,
        "embedUrl": embedUrl,
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
    );
};

export default VideoSchema;
